import { combineReducers } from 'redux';
import app from './ducks/app/reducer';
import persistent from './ducks/persistent/reducer'

export default combineReducers({
    app,
    persistent
});
